import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng } from '@ads/front-core/locales'

export const Cert: FC = () => (
  <Wrapper>
    <Content>
      <HeaderText>{lng('lppartners:cert.header')}</HeaderText>
      <Text>{lng('lppartners:cert.text')}</Text>
    </Content>
  </Wrapper>
)

const Wrapper = styled.div`
  background: #262a44;
`

const Content = styled.div`
  font-family: Poppins;
  max-width: 1348px;
  margin: 0 auto;
  padding: 60px;
  background: url(/img/partners/2.jpg) no-repeat right center;
  color: #fff;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 24px 16px 384px 16px;
    background: url(/img/partners/2-mob.jpg) no-repeat bottom center;
    background-size: 100% auto;
  }
`

const HeaderText = styled.p`
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 24px;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 26px;
  }
`

const Text = styled.p`
  font-size: 18px;
  font-weight: 200;
  max-width: 635px;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 18px;
    max-width: auto;
  }
`
